<template>
  <div>
    <div class="bg">
      <div class="title">
        数据总览
      </div>
      <div class="flex flex-between item-center mt20">
        <div v-for="(v, i) in titleList" :key="i" class="title-content item-center">
          <div class="flex">
            <div class="flex flex-center" style="width: 90px">
              <el-image
                  style="width: 66px;height:66px;"
                  :src="v.img"
              ></el-image>
            </div>
            <div class="flex flex-column flex-around">
              <div class="title-ms">{{ v.title }}</div>
              <div class="val-ms">{{ v.val }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg mt10">
      <div class="flex flex-between item-center">
        <div class="title">
          数据趋势
        </div>
        <div>
          <el-radio-group v-model="searchCondition.echarts.dateRaido" style="margin-right: 30px">
            <el-radio :label="1">昨天</el-radio>
            <el-radio :label="7">过去7天</el-radio>
            <el-radio :label="30">过去30天</el-radio>
          </el-radio-group>
          <el-date-picker
              v-model="searchCondition.echarts.dateList"
              type="daterange"
              size="small"
              class="mr10"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
          <el-select v-model="searchCondition.echarts.group" size="small" filterable placeholder="请选择员工">
            <el-option
                v-for="(item, i) in customerGroup"
                :key="i"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="mt40">
        <ve-line
            height="400px"
            :settings="chartLineSettings"
            :data="chartLineData"
            :colors="colors"
            :extend="{ dataZoom }"
        ></ve-line>
      </div>
    </div>
    <hm-content class="mt10">
      <div class="flex flex-between item-center">
        <div class="title">
          客服组明细
        </div>
        <div>
          <el-radio-group v-model="searchCondition.table.dateRaido" style="margin-right: 30px">
            <el-radio :label="1">昨天</el-radio>
            <el-radio :label="7">过去7天</el-radio>
            <el-radio :label="30">过去30天</el-radio>
          </el-radio-group>
          <el-date-picker
              v-model="searchCondition.table.dateList"
              type="daterange"
              size="small"
              class="mr10"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
          <el-select v-model="searchCondition.table.group" size="small" filterable placeholder="请选择员工">
            <el-option
                v-for="(item, i) in customerGroup"
                :key="i"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="mt40">
        <el-table
            :data="list"
            stripe
            border
            size="small"
            style="width: 100%"
            :default-sort = "{prop: 'date', order: 'descending'}"
        >
          <el-table-column
              header-align="center"
              align="center"
              prop="username"
              label="接待员工名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="date"
              label="总接待数"
              sortable
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="name"
              label="平均响应时长"
              sortable
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="180px"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button
                    size="small"
                    @click="cat(scope.row)"
                    class="blue"
                    type="text"
                >查看详情</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="text-center mt20">
          <el-pagination
              background
              layout="total,sizes,  prev, pager, next, jumper"
              :total="total"
              @current-change="paging"
              :current-page="currentPage"
          >
          </el-pagination>
        </div>
      </div>
    </hm-content>
  </div>

</template>

<script>
import VeLine from "v-charts/lib/line.common";
export default {
  components: {
    VeLine
  },
  data() {
    return {
      list: [{}],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        total: {},
        echarts: {
          dateRaido: "",
          dateList: [],
          group: ""
        },
        table: {}
      },
      titleList: [
        {
          title: "今日访客数",
          val: "9874",
          img: "https://imgcdn.hemiao100.com/ThemePictures/fangwenshu.png"
        },
        {
          title: "今日接待数",
          val: "987",
          img: "https://imgcdn.hemiao100.com/ThemePictures/jiedaishu.png"
        },
        {
          title: "今日平均响应时长(秒)",
          val: "0.00",
          img: "https://imgcdn.hemiao100.com/ThemePictures/xiangyingshichang.png"
        },
        {
          title: "总访客数",
          val: "68624",
          img: "https://imgcdn.hemiao100.com/ThemePictures/fangwenshu.png"
        },
        {
          title: "总接待数",
          val: "354",
          img: "https://imgcdn.hemiao100.com/ThemePictures/jiedaishu.png"
        },
        {
          title: "总平均响应时长(秒)",
          val: "98674",
          img: "https://imgcdn.hemiao100.com/ThemePictures/xiangyingshichang.png"
        },
      ],
      chartLineSettings: {
        labelMap: {
          dateValue: "日期",
          jieDaiNum: "接待数",
          avgXiangYingTime: "平均响应时长"
        }
      },
      chartLineData: {
        columns: [
          "dateValue", "jieDaiNum", "avgXiangYingTime"
        ],
        rows: [
          { dateValue: "11-30", jieDaiNum: 2950, avgXiangYingTime: 0 },
          { dateValue: "12-01", jieDaiNum: 2901, avgXiangYingTime: 2980 },
          { dateValue: "12-02", jieDaiNum: 8500, avgXiangYingTime: 10400 },
          { dateValue: "12-03", jieDaiNum: 3400, avgXiangYingTime: 6000 },
          { dateValue: "12-04", jieDaiNum: 8140, avgXiangYingTime: 9800 },
          { dateValue: "12--05", jieDaiNum: 5500, avgXiangYingTime: 9050 },
          { dateValue: "12-06", jieDaiNum: 4500, avgXiangYingTime: 5600 }
          /*{ 日期: "1月2日", 非分销订单: 1223, 分销订单: 123 },
          { 日期: "1月3日", 非分销订单: 2123, 分销订单: 1223 },
          { 日期: "1月4日", 非分销订单: 4123, 分销订单: 123 },
          { 日期: "1月5日", 非分销订单: 3123, 分销订单: 123 },
          { 日期: "1月6日", 非分销订单: 7123, 分销订单: 123 }*/
        ]
      },
      dataZoom: [
        {
          start: 0,
          type: "inside",
          show: true
        }
      ],
      colors: ["#B33AF7", "#43CDB7"],
      customerGroup: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    //查看
    cat(row) {
      this.$router.push({
        name: 'CustomerServiceEmployeeStatistics'
      });
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #fff;
  padding: 20px;
}
.title {
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 3px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  .desc {
    color: #999999;
    font-size: 14px;
  }
}
.title-content {
  width: 230px;
  background: #FFFFFF;
  box-shadow: 0px 0px 12px 0px rgba(221, 221, 221, 0.6);
  border-radius: 6px;
  padding: 20px 10px;
  .title-ms {
    font-size: 14px;
  }
}
</style>
